import useInactivityTimeout from '../../app/useInactivityTimeout';

const SessionTimeout = () => {

  const handleInactive = () => {
    window.location.assign('/');
  };

  // Initialize the inactivity timeout with the handler
  useInactivityTimeout(handleInactive);

  return null; // This is a utility component that doesn't render anything
};

export default SessionTimeout;